import {BrowserRouter as Router , Routes,Route} from 'react-router-dom';
import Home from './pages/Home';
import ProfileNew from './pages/ProfileNew';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Offers from './pages/Offers';
import Header from './components/Header';
import PrivateRoute from './components/PrivateRoute';
import ForgotPassword from './pages/ForgotPassword';
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CreateListing from './pages/CreateListing';
import EditListing from './pages/EditListing';
import Listing from './pages/Listing';
import Category from './pages/Category';
  

function App() {
  return (
    <>
      <Router>
      <Header />
        <Routes>
          <Route path='/' element={<Home />}></Route>
          <Route path="/profile" element={<PrivateRoute />}>
              <Route path='/profile' element={<ProfileNew />}></Route>
          </Route>
          <Route path='/sign-in' element={<SignIn />}></Route>
          <Route path='/sign-up' element={<SignUp />}></Route>
          <Route path='/offers' element={<Offers />}></Route>
          <Route path='/category/:categoryName/:listingId' element={<Listing />}></Route>
          <Route path='/category/:categoryName' element={<Category />}></Route>
          <Route path="/create-listing" element={<PrivateRoute />}>
              <Route path='/create-listing' element={<CreateListing />}></Route>
          </Route>
          <Route path="/edit-listing" element={<PrivateRoute />}>
              <Route path='/edit-listing/:listingId' element={<EditListing />}></Route>
          </Route>
          <Route path='/forgotpassword' element={<ForgotPassword />}></Route>
        </Routes>
      </Router>
      <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
        />
    </>
  );
}

export default App;
